import { render, staticRenderFns } from "./PayerPanel.vue?vue&type=template&id=0587e380&scoped=true"
import script from "./PayerPanel.vue?vue&type=script&lang=js"
export * from "./PayerPanel.vue?vue&type=script&lang=js"
import style0 from "./PayerPanel.vue?vue&type=style&index=0&id=0587e380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587e380",
  null
  
)

export default component.exports